export enum DELAY_COLORS {
	green = 'green',
	orange = 'orange',
	red = 'red',
}

export const SHORT_DELAY = 5;
export const LONG_DELAY = 20;
